import {useContext} from 'react';

import {Route, Routes, useLocation} from 'react-router-dom';

import {AppHeader} from '../components/AppHeaders/AppHeader';
import {ErrorMessage} from '../components/ErrorMessage/ErrorMessage';
import LinkedInCallback from '../components/LinkedInCallback/LinkedInCallback';
import {PageContainer} from '../components/PageContainer/PageContainer';
import {FeatureFlagContext} from '../contexts/FeatureFlagContext/FeatureFlagContext';
import {B2BMarketingPage} from '../pages/b2b/B2BMarketingPage';
import {B2BResultsPage} from '../pages/b2b/B2BResultsPage';
import Home from '../pages/talent/home/TalentHomePage';
import {ChatBasedTalentSurveyPage} from '../pages/talent/survey/ChatBasedTalentSurveyPage';
import {ChatBasedTalentSurveyResultsPage} from '../pages/talent/survey/ChatBasedTalentSurveyResultsPage';
import {TalentSurveyWithIdPage} from '../pages/talent/survey/TalentSurveyWithIdPage';
import {ForgotPasswordPage} from '../pages/user/password/ForgotPasswordPage';
import {PasswordResetPage} from '../pages/user/password/PasswordResetPage';
import LogInPage from '../pages/user/registration/LogInPage';
import LogOutPage from '../pages/user/registration/LogOutPage';
import SignUpPage from '../pages/user/registration/SignupPage';

import {LoginGuard} from './RouteGuards/LoginGuard';

export const PublicRoutes = () => {
  const {flags, isLoading} = useContext(FeatureFlagContext);
  const location = useLocation();
  const isChatBasedTalentSurvey = flags.CHAT_BASED_TALENT_SURVEY_ENABLED;

  if (isLoading) {
    return null;
  }

  return (
    <div>
      <PageContainer>
        <AppHeader type={location.pathname === '/b2b' ? 'b2b' : 'public'} />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route element={<LoginGuard />}>
            <Route path='/login' element={<LogInPage />} />
          </Route>
          <Route path='/logout' element={<LogOutPage />} />
          <Route path='/talent/sign-up/:talent_survey_id' element={<SignUpPage />} />
          {isChatBasedTalentSurvey && (
            <>
              <Route path='/talent/survey' element={<ChatBasedTalentSurveyPage />} />
              <Route path='/talent/survey_results' element={<ChatBasedTalentSurveyResultsPage />} />
            </>
          )}
          <Route path='/talent/survey/:talent_survey_id' element={<TalentSurveyWithIdPage />} />
          <Route path='/password/reset?' element={<PasswordResetPage />} />
          <Route path='/password/request-reset' element={<ForgotPasswordPage />} />
          <Route path='/oauth/linkedin/callback' element={<LinkedInCallback />} />
          <Route path='/b2b' element={<B2BMarketingPage />} />
          <Route path='/b2b/results' element={<B2BResultsPage />} />
          <Route path='*' element={<ErrorMessage isOutOfBounds />} />
        </Routes>
      </PageContainer>
    </div>
  );
};
